import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleLogout } from '../../utils/logout';
import { writeAuditLog } from '../../lib/auditLogger';
import { auth } from '../../firebase';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      try {
        const currentUser = auth.currentUser;
        if (currentUser) {
          await writeAuditLog({
            action: 'SYSTEM_LOGOUT',
            resourceType: 'system_admin',
            resourceId: currentUser.uid,
            metadata: { source: 'admin_console' }
          });
        }
        await handleLogout();
        // ログアウト後、管理者ログインページにリダイレクト
        navigate('/admin/login');
      } catch (error) {
        console.error('Error during admin logout:', error);
        // エラーが発生した場合でも、ログインページへのリダイレクトを試みる
        navigate('/admin/login');
      }
    };

    performLogout();
  }, [navigate]);

  // ログアウト処理中に表示するメッセージ
  return <div>Logging out...</div>;
};

export default Logout;
